import { render, staticRenderFns } from "./POSLookup.vue?vue&type=template&id=9c477cf2&"
import script from "./POSLookup.vue?vue&type=script&lang=js&"
export * from "./POSLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports